(function (util, $, undefined) {
	util.downloadFile = function (url, options) {
		var dlg = null;
		var settings = $.extend(true,{}, {
            httpMethod: "POST",
            prepareCallback: function (url) {
                dlg = konto.dialogs.modal({
                    title: "Generiranje izvještaja",
                    content: "Molimo pričekajte."
                });
            },
            successCallback: function () {
                if (dlg)
                    dlg.close();
            },
            failCallback: function (responseHtml, url) {
                if (dlg)
                    dlg.close();
            
                // JSON greške bi se mogle naći u HTML-u.
                var ispisan = false;
                var html = $(responseHtml);   
                try {                      
                    var json = $.parseJSON(html.text());
                    if (json && json.error) {
                        ispisan = true;
                        $.dialog({
                            content: json.error
                        });
                    }
                }
                catch (e) { }
                
                if (ispisan === false) {
                    if (responseHtml == '')
                        responseHtml = "Nema podataka za zadane parametre. Provjerite i promijenite unesene parametre izvještaja.";
                        $.dialog({
                        content: responseHtml
                    });
                }
            }
        }, options);
        
        url = kontorouter.getModulPath(KUtils.addParamToUrl(url, 'fileDownload', true));

        //stari nacin - problem ako vec postoje parametri
        //url = kontorouter.getModulPath(url + "?fileDownload");
        
        var settings = $.extend({}, settings);
        $.fileDownload(url, settings);
	};
	util.downloadIzvjestaj = function (url) {
		$.fileDownload(url, {
			preparingMessageHtml: "Izvještaj se generira. Molimo pričekajte.",
			//failMessageHtml: "Javila se greška prilikom preuzimanja. Pokušajte ponovno.",
			failCallback: function (responseHtml, url) {
				konto.dialogs.greska({
					content: "Javila se greška prilikom preuzimanja. Pokušajte ponovno.<br />Detalji:<br />" + responseHtml
				});
			}
		});
	};
	
	util.getFilename = function (path) {
		return path.replace(/^.*[\\\/]/, '');
	};
}(window.KFileUtils = window.KFileUtils || {}, jQuery));